// Compatibility shim for Next.js navigation in Vite/React Router
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { useMemo } from 'react';

// Hook to replace useRouter from Next.js
export function useRouter() {
  const navigate = useNavigate();
  const location = useLocation();
  
  return useMemo(() => ({
    push: (path: string) => navigate(path),
    replace: (path: string) => navigate(path, { replace: true }),
    refresh: () => window.location.reload(),
    back: () => navigate(-1),
    forward: () => navigate(1),
    pathname: location.pathname,
  }), [navigate, location.pathname]);
}

// Re-export useSearchParams from react-router-dom
export { useSearchParams };

// Hook to replace usePathname from Next.js
export function usePathname() {
  const location = useLocation();
  return location.pathname;
}

// Hook for query params - simpler version
export function useSearchParam(key: string) {
  const [searchParams] = useSearchParams();
  return searchParams.get(key);
}
